export const parseFullName = (name) => {
    if (!name) {
        return null;
    }
    let firstName = "";
    let lastName = "";
    if (name.includes(".")) {
        [firstName, lastName] = name.split(".");
    }
    else if (name.includes(" ")) {
        [firstName, lastName] = name.split(" ");
    }
    if (!firstName || !lastName) {
        if (process.env.NODE_ENV === "development") {
            // eslint-disable-next-line no-console
            console.warn("Invalid name format. Name must include both first and last names.");
        }
        return null;
    }
    return { firstName, lastName };
};
export function generateInitials(name) {
    const parsedName = parseFullName(name);
    if (!parsedName) {
        return "";
    }
    const { firstName, lastName } = parsedName;
    return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
}
//# sourceMappingURL=nameUtils.js.map